import type { ReactNode } from "react";
import { tv } from "tailwind-variants";

import { EMPTY_STATE_SURFACE_CLASS_NAME } from "./empty-state-styles";

const tableEmptyState = tv({
  slots: {
    root: "flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center",
    iconWrapper: "text-text-secondary",
    title: "text-text-primary text-lg font-semibold",
    description: "text-text-secondary text-sm",
  },
  variants: {
    variant: {
      default: { root: EMPTY_STATE_SURFACE_CLASS_NAME },
      content: { root: "w-full" },
    },
  },
});

export function TableEmptyState({
  icon,
  title,
  description,
  action,
  className,
  variant = "default",
}: Readonly<{
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  variant?: "default" | "content";
}>) {
  const styles = tableEmptyState({ variant });

  return (
    <div className={styles.root({ className })}>
      {icon && <div className={styles.iconWrapper()}>{icon}</div>}

      {title && <h3 className={styles.title()}>{title}</h3>}

      {description && <p className={styles.description()}>{description}</p>}

      {action}
    </div>
  );
}
